import React from 'react';
import { Box, Typography } from '@mui/material';

const FinancialReporting = () => {
  return (
    <Box sx={{ py: 2 }}>
      <Typography variant="h4" sx={{ fontWeight: 700, color: 'text.primary' }}>
        Financial Reporting
      </Typography>
    </Box>
  );
};

export default FinancialReporting;
